<template>
  <div 
    v-if="openTable"
    :key="openTable.table_id"
    :style="billStyle"
  >
    <v-layout
      row
      align-center
      @click="showBill"
    >
      <v-flex
        xs10
        class="nowrap-text"
        :style="nameStyle"
      >
        {{ billInfo }}
      </v-flex>
      <v-flex
        xs2
        text-xs-right
      >
        <v-btn
          icon
          small
        >
          <v-icon
            :color="theme.btn_color_secondary"
            small
          >{{ icon }}</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    openTable: {
      type: Object,
      default: null
    },
    billStyle: {
      type: Object,
      default: () => ({
        cursor: 'pointer'
      })
    },
    index: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'tables'
    ]),
    ...mapGetters('order', [
      'orderMsg', 'openTables'
    ]),
    nameStyle () {
      return {
        color: this.theme.orders_title_color
      }
    },
    icon () {
      let icon = 'fa-chevron-right'
      if (this.loading) {
        icon = 'fas fa-circle-notch fa-spin'
      }
      return icon
    },
    bill () {
      return this.openTable.bill ? this.openTable.bill : null
    },
    billInfo () {
      const table = this.openTable.m_table ? ' (' + this.$t('table') + ': ' + this.openTable.m_table.Name + ')' : ''
      if (this.bill && this.bill.billno) {
        return this.$t('bill') + ': ' + this.bill.billno + table
      } else if (this.openTable.m_table) {
        return this.$t('bill') + table
      }
      return ''
    }
  },
  methods: {
    async showBill () {
      // Have to wait here because POS is doing the calculation, and will takes some times
      this.loading = true
      await this.$store.dispatch('order/previewBill', this.openTable.table_id)
      this.loading = false

      if (this.orderMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Unable to fetch bill',
          text: this.orderMsg,
          modal: true
        })
      } else {
        if (this.bill) {
          if (this.bill.billno && parseFloat(this.bill.subtotal) > 0) {
            this.$router.push({ name: 'bill', params: { id: this.openTable.table_id.toString() }})
          } else {
            // Recheck this logic
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: this.$t('bill_not_found_title'),
              text: this.$t('bill_not_found_notice') + this.$t('bill_not_found_notice2'),
              modal: true
            })
            await this.$store.dispatch('order/fetchMemberOpenTables')
          }
        } else {
          // Refetch this bill
        }
      }
    }
  }
}
</script>

<style scoped>
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/BillLine.vue